import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
});

export const DIALOG_CONTENT_SX = {
  px: { xs: 3, sm: 5 },
  py: 4,
  pt: 6,
  maxWidth: '100%',
  '& .MuiFormHelperText-root': { mt: 0.5 },
  '& .MuiTypography-body2': { mt: 0.5 },
};

export default theme;
